import moment from "moment";
import React, { useState } from "react";
import { Dialog } from "@mui/material";

import { InputLabelStyle } from "views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/constants";
import CustomDatePicker from "views/pages/manage/common/commonComponents/CustomDatePicker";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

const EditTicketInfo = ({
  ticketDetails,
  setTicketDetails,
  closeTicketDialog,
  saveTicketInfo,
}) => {
  const [form, setForm] = useState(ticketDetails);
  const { id, date, description } = form;

  const filterFormHandler = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const handleSave = () => {
    const payload = {
      id: id.trim(),
      date: moment(date).format("YYYY-MM-DD"),
      description: description.trim(),
    };
    setTicketDetails(payload);
    saveTicketInfo();
  };

  const isDisabled = !id.trim() || !date || description.length < 10;

  return (
    <Dialog
      aria-label="Edit Ticket Information"
      open={true}
      PaperProps={{
        sx: {
          minHeight: "450px",
          minWidth: "370px",
          borderRadius: "12px",
          padding: "20px",
        },
      }}
    >
      <h3 class="text-lg text-bold text-gray-800 mb-3">
        Ticket Information Required
      </h3>

      <AInput
        type="text"
        label="Ticket ID *"
        value={id}
        handler={(value) => {
          filterFormHandler("id", value);
        }}
        placeholder="Enter ticket ID"
      />

      <label style={{ ...InputLabelStyle, marginTop: "16px" }}>
        Ticket Date
      </label>
      <CustomDatePicker
        placeHolder="Ticket Date"
        // minDate={moment()}
        value={date ? moment(date) : moment()}
        // handler={(index, date, keyName) => {
        //   filterFormHandler("date", date);
        // }}
        minDate={moment()}
        maxDate={moment()}
      />

      <label style={{ ...InputLabelStyle, marginTop: "16px" }}>
        Ticket Description * (min 10 characters)
      </label>
      <textarea
        className="w-100 text-sm p-2"
        value={description}
        onChange={(e) => filterFormHandler("description", e.target.value)}
        placeholder="Describe the reason for editing student information"
        rows={3}
        maxLength={500} // char limit: 500
      />
      <small>{description.length}/500 characters</small>

      <div className="mt-auto d-flex justify-content-end">
        <button
          onClick={closeTicketDialog}
          className="px-4 py-2 border rounded"
        >
          Cancel
        </button>

        <AButton
          variant="primary_filled"
          disabled={isDisabled}
          onClick={handleSave}
        >
          Start Editing
        </AButton>
      </div>
    </Dialog>
  );
};

export default EditTicketInfo;
